/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSqlConnectorStatusFromDiscriminatorValue, serializeHeartbeatSqlConnectorRequest, serializeSqlConnectorStatus, type ErrorResponse, type HeartbeatSqlConnectorRequest, type InternalErrorResponse, type SqlConnectorStatus } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/sql-connector/{connectorId}/heartbeat
 */
export interface HeartbeatRequestBuilder extends BaseRequestBuilder<HeartbeatRequestBuilder> {
    /**
     * A heartbeat is the connector saying it is still alive. Each call stamps the connector's lastHeartbeatAt, records the status it reports, replaces the recorded version when one is supplied, and merges the supplied metadata over what is already stored. It is a periodic call — send it on a timer, and expect to send it many times. Nothing marks a connector offline on its behalf: a connector that stops calling simply stops advancing lastHeartbeatAt, and staleness is judged from that timestamp. Register the connector first via POST /api/sql-connector/register.
     * @param body A single liveness ping from a registered connector.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SqlConnectorStatus>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: HeartbeatSqlConnectorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SqlConnectorStatus | undefined>;
    /**
     * A heartbeat is the connector saying it is still alive. Each call stamps the connector's lastHeartbeatAt, records the status it reports, replaces the recorded version when one is supplied, and merges the supplied metadata over what is already stored. It is a periodic call — send it on a timer, and expect to send it many times. Nothing marks a connector offline on its behalf: a connector that stops calling simply stops advancing lastHeartbeatAt, and staleness is judged from that timestamp. Register the connector first via POST /api/sql-connector/register.
     * @param body A single liveness ping from a registered connector.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: HeartbeatSqlConnectorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const HeartbeatRequestBuilderUriTemplate = "{+baseurl}/api/sql-connector/{connectorId}/heartbeat";
/**
 * Metadata for all the requests in the request builder.
 */
export const HeartbeatRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: HeartbeatRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSqlConnectorStatusFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeHeartbeatSqlConnectorRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
